import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (value && typeof value === 'string' && !value.trim()) {
            return { whitespace: true };
        }

        return null;
    };
}
